module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-4-photo-2-a843170f977d7b941bfca03bb05239c8.webp";